export enum MessageContentTypeEnum {
  Text = "TEXT",
  Attachment = "ATTACHMENT",
  AudioCall = "AUDIO_CALL",
  VideoCall = "VIDEO_CALL",
  System = "SYSTEM"
}
